import { render, staticRenderFns } from "./Enrol.vue?vue&type=template&id=53a95659&"
import script from "./Enrol.vue?vue&type=script&lang=js&"
export * from "./Enrol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports